{
  "login": {
    "errors": {
      "unexpected": "Não foi possível continuar agora. Tente novamente.",
      "additionalVerification": "Verificação adicional necessária",
      "invalidCredentials": "Código ou senha inválidos",
      "sendCode": "Erro ao enviar código"
    },
    "email": {
      "title": "Bem-vindo de volta!",
      "subtitle": "Digite seu email para acessar a plataforma",
      "label": "Email",
      "placeholder": "seu@email.com",
      "continue": "Continuar",
      "forgotPassword": "Esqueceu a senha?"
    },
    "verify": {
      "title": "Verificação de Segurança",
      "subtitle": "Escolha um método para confirmar sua identidade",
      "password": {
        "title": "Senha",
        "description": "Digite sua senha de acesso",
        "submit": "Entrar"
      },
      "emailCode": {
        "title": "Código por Email",
        "description": "Receba um código de 6 dígitos no seu email",
        "send": "Enviar código para {{email}}",
        "sentTo": "Código enviado para <email>{{email}}</email>",
        "submit": "Verificar",
        "resendIn": "Reenviar em {{seconds}}s",
        "sending": "Enviando...",
        "resend": "Reenviar código"
      },
      "sms": {
        "title": "Código por SMS",
        "description": "Verificação por celular",
        "comingSoon": "Em breve"
      },
      "back": "Voltar"
    }
  },
  "forgotPassword": {
    "validation": {
      "invalidEmail": "Email inválido"
    },
    "errors": {
      "send": "Erro ao enviar email"
    },
    "success": {
      "title": "Email enviado!",
      "description": "Se o email existir em nossa base, você receberá um link de recuperação."
    },
    "backToLogin": "Voltar ao login",
    "title": "Recuperar senha",
    "subtitle": "Digite seu email para receber um link de recuperação",
    "emailLabel": "Email",
    "emailPlaceholder": "seu@email.com",
    "submit": "Enviar link"
  },
  "resetPassword": {
    "validation": {
      "minLength": "Senha deve ter no mínimo 8 caracteres",
      "complexity": "Deve conter maiúscula, minúscula e número",
      "mismatch": "As senhas não coincidem"
    },
    "invalid": {
      "title": "Link inválido",
      "description": "O link de recuperação é inválido ou expirou.",
      "requestNew": "Solicitar novo link"
    },
    "success": {
      "title": "Senha alterada!",
      "description": "Sua senha foi redefinida com sucesso. Faça login com a nova senha.",
      "goToLogin": "Ir para o login"
    },
    "toast": {
      "success": "Senha alterada com sucesso!"
    },
    "errors": {
      "reset": "Erro ao redefinir senha. O link pode ter expirado."
    },
    "title": "Nova senha",
    "subtitle": "Digite sua nova senha abaixo",
    "passwordLabel": "Nova senha",
    "passwordPlaceholder": "Mínimo 8 caracteres",
    "confirmLabel": "Confirmar senha",
    "confirmPlaceholder": "Repita a senha",
    "submitting": "Redefinindo...",
    "submit": "Redefinir senha",
    "backToLogin": "Voltar ao login"
  },
  "platformRoot": {
    "title": "Área de membros para quem ensina",
    "description": "Você chegou à Xtreed. Se você é aluno, entre pelo endereço que a sua escola enviou — cada área de membros tem o seu.",
    "devShortcuts": "Atalhos de desenvolvimento"
  },
  "deepLink": {
    "errors": {
      "incompleteLink": "O link de acesso está incompleto ou mal-formado. Peça para o administrador gerar um novo link.",
      "validateFailed": "Não foi possível validar o link de acesso."
    },
    "footer": "Problemas com o acesso? <link>Ir para o login tradicional</link>",
    "verifying": {
      "title": "Verificando acesso",
      "description": "Estamos validando seu link seguro. Isso leva apenas um instante.",
      "steps": {
        "token": {
          "title": "Validando token",
          "subtitle": "Conferindo assinatura e expiração"
        },
        "auth": {
          "title": "Autenticando usuário",
          "subtitle": "Criando sessão segura"
        },
        "redirect": {
          "title": "Redirecionando",
          "subtitle": "Levando você para a plataforma"
        }
      },
      "doNotClose": "Não feche esta aba durante a verificação"
    },
    "success": {
      "welcome": "Bem-vindo, {{name}}!",
      "granted": "Acesso liberado!",
      "description": "Autenticação concluída com sucesso. Estamos levando você para a plataforma…",
      "redirecting": "Redirecionando"
    },
    "error": {
      "title": "Não foi possível entrar",
      "fallback": "Houve um problema ao validar seu link de acesso. Tente novamente.",
      "reasonsTitle": "Motivos mais comuns",
      "reasons": {
        "used": "O link já foi utilizado (uso único)",
        "expired": "O link expirou (válido por 24 horas)",
        "modified": "O link foi modificado ou está incompleto"
      },
      "retry": "Tentar novamente",
      "goToLogin": "Ir para o login"
    }
  },
  "devflixAuthorize": {
    "errors": {
      "incompleteRequest": "A solicitação da DevFlix está incompleta. Volte e tente novamente.",
      "authorizeFailed": "Não foi possível autorizar a DevFlix. Confirme seu acesso e tente novamente."
    },
    "title": {
      "unauthorized": "Acesso não autorizado",
      "opening": "Abrindo sua DevFlix"
    },
    "confirming": "Confirmando sua conta e seus acessos com segurança…"
  },
  "terms": {
    "toast": {
      "success": "Termos aceitos com sucesso!",
      "error": "Erro ao salvar aceite dos termos. Tente novamente."
    },
    "header": "Termos de Uso",
    "title": "Termos e Condições de Uso",
    "subtitle": "Para continuar usando a plataforma, leia e aceite os termos abaixo.",
    "iframeTitle": "Termos e Condições",
    "agree": "Li e concordo com os <bold>Termos e Condições de Uso</bold> de {{name}}.",
    "auditInfo": "Ao aceitar, seu endereço IP e localização aproximada serão registrados para fins de auditoria. O navegador solicitará permissão para acessar sua localização.",
    "submitting": "Registrando aceite...",
    "submit": "Aceitar e Continuar"
  },
  "magicLink": {
    "validation": {
      "invalidEmail": "Email inválido"
    },
    "errors": {
      "send": "Erro ao enviar link mágico"
    },
    "sent": {
      "title": "Link Enviado!",
      "description": "Enviamos um link de acesso para <email>{{email}}</email>",
      "nextSteps": "Próximos passos:",
      "steps": {
        "inbox": "Verifique sua caixa de entrada",
        "click": "Clique no link recebido",
        "auto": "Você será conectado automaticamente"
      },
      "notReceived": "Não recebeu? Verifique a pasta de spam ou tente novamente em alguns minutos.",
      "backToLogin": "Voltar ao Login"
    },
    "title": "Magic Link",
    "subtitle": "Digite seu email e receba um link de acesso seguro",
    "emailLabel": "Email",
    "emailPlaceholder": "seu@email.com",
    "sending": "Enviando...",
    "submit": "Enviar Link Mágico",
    "back": "Voltar"
  },
  "socialButton": {
    "connecting": "Conectando...",
    "continueWith": "Continuar com {{provider}}"
  },
  "socialButtons": {
    "divider": {
      "login": "ou entrar com",
      "register": "ou cadastrar com"
    },
    "withProvider": {
      "login": "Entrar com {{provider}}",
      "register": "Cadastrar com {{provider}}"
    },
    "magicLink": "Link mágico por email",
    "privacy": {
      "register": "Ao se cadastrar com redes sociais, você concorda que podemos acessar suas informações básicas de perfil.",
      "login": "Seus dados estão protegidos e não compartilhamos com terceiros."
    }
  },
  "social": {
    "errors": {
      "connect": "Erro ao conectar com {{provider}}",
      "login": "Erro ao fazer login com {{provider}}"
    },
    "welcomeNew": "Bem-vindo! Sua conta foi criada com {{provider}}",
    "loggedIn": "Login realizado com {{provider}}"
  },
  "setPassword": {
    "validation": {
      "minLength": "Senha deve ter no mínimo 8 caracteres",
      "complexity": "Deve conter maiúscula, minúscula e número",
      "mismatch": "As senhas não coincidem"
    },
    "invalid": {
      "title": "Link inválido",
      "description": "O link de acesso é inválido ou já foi utilizado.",
      "requestNew": "Solicitar novo link"
    },
    "success": {
      "title": "Senha definida!",
      "description": "Sua senha foi definida com sucesso. Faça login para acessar.",
      "goToLogin": "Ir para o login"
    },
    "toast": {
      "success": "Senha definida com sucesso!"
    },
    "errors": {
      "set": "Erro ao definir a senha. O link pode ter expirado."
    },
    "title": "Defina sua senha",
    "subtitle": "Escolha uma senha para acessar sua área de membros",
    "passwordLabel": "Senha",
    "passwordPlaceholder": "Mínimo 8 caracteres",
    "confirmLabel": "Confirmar senha",
    "confirmPlaceholder": "Repita a senha",
    "submitting": "Definindo...",
    "submit": "Definir senha",
    "backToLogin": "Voltar ao login"
  }
}
